export enum EffortPlanningConfig {
  Task = 'TASK',
  Phase = 'PROJECT_PHASE',
}
